import React, { useEffect, useState } from "react";
import { trackEvent } from "../utils/appInsights";

const DEFAULT_SITES = {
  "suwanee":     { label: "Suwanee / GA",     url: "https://suwanee.tdsnx.tdsynnex.com/dash.aspx" },
  "swedesboro":  { label: "Swedesboro / NJ",  url: "https://Swedesboro.tdsnx.tdsynnex.com/dash.aspx" },
  "south-bend":  { label: "South Bend / IN",  url: "https://southbend.tdsnx.tdsynnex.com/dash.aspx" },
  "ft-worth":    { label: "Ft. Worth / TX",   url: "https://ftworth.tdsnx.tdsynnex.com/dash.aspx" },
  "fontana":     { label: "Fontana / CA",     url: "https://fontana.tdsnx.tdsynnex.com/dash.aspx" },
  "romeoville":  { label: "Romeoville / IL",  url: "https://Romeoville.tdsnx.tdsynnex.com/dash.aspx" },
  "southaven":   { label: "Southaven / MS",   url: "https://Southaven.tdsnx.tdsynnex.com/dash.aspx" },
  "chino":       { label: "Chino / CA",       url: "https://chino.tdsnx.tdsynnex.com/dash.aspx" },
};

export default function Locations({ siteId, sites = DEFAULT_SITES, className }) {
  const site = sites[siteId];
  const [isLoading, setIsLoading] = useState(true);
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    if (!site) {
      trackEvent("SiteUnknown", { siteId: String(siteId) });
      return;
    }
    setIsLoading(true);
    setBlocked(false);

    const t = setTimeout(() => {
      setIsLoading((loading) => {
        if (loading) {
          setBlocked(true);
          trackEvent("SiteIframeLoadTimeout", {
            siteId,
            siteLabel: site.label,
          });
        }
        return loading;
      });
    }, 6000);
    return () => clearTimeout(t);
  }, [siteId, site]);

  if (!site) {
    return (
      <div className={className} style={{ padding: 16 }}>
        <strong>Unknown site:</strong> <code>{siteId}</code>
      </div>
    );
  }

  return (
    <div className={className} style={{ position: "relative", width: "100%", height: "100%" }}>
      {isLoading && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "grid",
            placeItems: "center",
            background: "rgba(255,255,255,0.5)",
            zIndex: 1,
          }}
        >
          Loading…
        </div>
      )}

      {blocked && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            gap: 8,
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(255,255,255,0.85)",
            zIndex: 2,
            textAlign: "center",
            padding: 16,
          }}
        >
          <strong>This site may not allow embedding in an iframe.</strong>
          <a href={site.url} target="_blank" rel="noopener noreferrer">
            Open in a new tab
          </a>
        </div>
      )}

      <iframe
        key={site.url}
        src={site.url}
        title={`External: ${site.label}`}
        style={{ border: "none", width: "100%", height: "100%" }}
        sandbox="allow-forms allow-pointer-lock allow-popups allow-same-origin allow-scripts allow-downloads"
        allow="accelerometer; clipboard-write; encrypted-media; geolocation; microphone; camera"
        referrerPolicy="no-referrer-when-downgrade"
        onLoad={() => {
          setIsLoading(false);
          setBlocked(false);
        }}
        onError={() => {
          setIsLoading(false);
          trackEvent("SiteIframeError", { siteId, siteLabel: site.label });
        }}
      />
    </div>
  );
}
